import { render, staticRenderFns } from "./FailureNode.vue?vue&type=template&id=5c544fe6"
import script from "./FailureNode.vue?vue&type=script&lang=js"
export * from "./FailureNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports